import React, { Component } from 'react';
import HeaderTwo from './components/HeaderTwo';
import HeroSlider from './components/HeroSlider';
import AboutUs from './components/AboutUs';
import PortfolioFilter from './components/PortfolioFilter';
import TestimonialSlider from './components/TestimonialSlider';
import FooterTwo from './components/FooterTwo';

export default class HomeOne extends Component {
    componentDidMount(){
        document.title = "REAL FM | People Technology Reporting";
    }
    render() {
        return (
            <div className="main-wrapper" >

                {/* Header */}
                <HeaderTwo />

                {/* Hero Slider */}
                <HeroSlider />

                {/* About Area */}
                <AboutUs />

                {/* Testimonial Slider */}
                <TestimonialSlider />

                {/* Portfolio Filter */}
                <PortfolioFilter />
               
                {/* Footer */}
                <FooterTwo />

            </div>
        )
    }
}
